import PropTypes from "prop-types";
import { Box, Grid, Modal, Typography } from "@mui/material";
import CloseIconButton from "./CloseIconButton";
import theme from "@/helpers/theme";

const MUIModal = ({
  open = false,
  onClose,
  modalHeader,
  headerClasses = "",
  modalFooter,
  footerClasses = "",
  children,
  sx,
  classToOveride,
  hasCloseButton = false,
  hasBorderBottom = true,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        ...sx,
      }}
    >
      <Box
        sx={{
          position: "absolute",
          bgcolor: "background.white",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          borderRadius: "1rem",
          width: { xs: "90%", md: "50%" },
          outline: "none",
          p: "1.25rem",
          ...classToOveride,
        }}
      >
        {modalHeader && (
          <Box
            component={"div"}
            sx={{
              borderBottom: hasBorderBottom
                ? `1px solid ${theme.palette.color.aigColor66}`
                : "",
              // mx: 3,
              mb: 1,
              ...headerClasses,
            }}
          >
            <Grid container justifyContent={"space-between"}>
              <Grid item>{modalHeader}</Grid>
              {hasCloseButton && (
                <Grid item>
                  <CloseIconButton onClose={onClose} />
                </Grid>
              )}
            </Grid>
          </Box>
        )}
        {hasCloseButton && !modalHeader ? (
          <CloseIconButton onClose={onClose} />
        ) : null}
        <Typography component={"div"} sx={{ minHeight: "3.125rem" }}>
          {children}
        </Typography>

        {modalFooter && (
          <Typography
            component={"div"}
            sx={{
              pt: 1,
              mt: 1,
              mx: 3,
              borderTop: `1px solid ${theme.palette.color.aigColor66}`,
              ...footerClasses,
            }}
          >
            {modalFooter}
          </Typography>
        )}
      </Box>
    </Modal>
  );
};

MUIModal.propTypes = {
  children: PropTypes.node,
  classToOveride: PropTypes.object,
  footerClasses: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  hasBorderBottom: PropTypes.bool,
  hasCloseButton: PropTypes.bool,
  headerClasses: PropTypes.string,
  modalFooter: PropTypes.node,
  modalHeader: PropTypes.node,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  sx: PropTypes.object,
};

export default MUIModal;
